import axios from 'axios';
import * as Sentry from "@sentry/vue";
import { createAppRouter } from '../routing';
import useAuth from '../composables/useAuth';
import { useRoute } from 'vue-router';

const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_URL || "https://be.irise.co.id/api",
    timeout: 300000,
});


axiosInstance.interceptors.request.use((config) => {
    if (useAuth().get().token) {
        config.headers.Authorization = `Bearer ${useAuth().get().token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (!error.response) {
            Sentry.withScope((scope) => {
                scope.setTag('source', 'axios');
                scope.setTag('missing_response', 'true');
                scope.setContext('network', {
                    online: typeof navigator !== 'undefined' ? navigator.onLine : null,
                });
                scope.setContext('request', {
                    url: error?.config?.url ?? null,
                    method: error?.config?.method ?? null,
                    baseURL: error?.config?.baseURL ?? null,
                    timeout: error?.config?.timeout ?? null,
                });
                Sentry.captureException(error);
            });

            let message = 'Koneksi internet terputus.';

            if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
                let translations: any = null;
                try {
                    const cached = localStorage.getItem('translations');
                    if (cached) {
                        translations = JSON.parse(cached);
                    }
                } catch (e) {
                    // Ignore cache parsing errors
                }

                const offlineMsg = translations?.ERROR_OFFLINE || 'Koneksi internet Anda terputus. Silakan periksa kembali koneksi Anda dan coba kembali.';
                const unavailableMsg = translations?.ERROR_UNAVAILABLE || 'Koneksi internet terputus.';

                message = !navigator.onLine ? offlineMsg : unavailableMsg;
            }

            error.response = {
                data: {
                    message: message,
                },
                status: null,
            };
        }


        const nginxStatusMessages: Record<number, string> = {
            400: 'Permintaan tidak valid.',
            403: 'Anda tidak memiliki akses untuk melakukan ini.',
            404: 'Halaman atau resource yang diminta tidak ditemukan.',
            413: 'File / data yang diunggah terlalu besar.',
            429: 'Terlalu banyak permintaan. Silakan coba lagi nanti.',
            // 500: 'Terjadi kesalahan pada server. Silahkan coba lagi nanti',
            502: 'Server sedang tidak dapat dijangkau.',
            503: 'Layanan sedang tidak tersedia. Silakan coba lagi nanti.',
            504: 'Waktu koneksi ke server habis.',
        };

        const status = error.response?.status;
        if (status && nginxStatusMessages[status] && !error.response.data?.message) {
            error.response.data = {
                ...error.response.data,
                message: nginxStatusMessages[status],
            };
        }

        if (error.response?.status === 401 || error.response.data?.message === "Token has expired, please refresh token.") {
            useAuth().del()

            const currentPath = createAppRouter().currentRoute.value.path;
            if (!error?.response?.access_token) {
                if (!currentPath.includes('/Mentor/SignIn')) {
                    createAppRouter().replace({ path: '/SignIn' });
                }else{
                    createAppRouter().replace({ path: '/Mentor/SignIn' });
                }
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
